import { Injectable } from '@angular/core';
import { Maintenance, PagedResult } from '@core/interfaces';
import { LocationSector } from '@core/interfaces/locations-sectors';
import { Apollo } from 'apollo-angular';
import { GET_LOCATION_ENVIRONMENT_MAINTENANCES_QUERY } from './location-sectors.query';

interface GetEnvironmentMaintenancesParams {
  id: string;
  take: number;
  after?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TabMaintenancesService {
  constructor(private readonly apollo: Apollo) {}

  public async getEnvironmentMaintenances({ id, take, after }: GetEnvironmentMaintenancesParams): Promise<PagedResult<Maintenance>> {
    return this.apollo
      .query<LocationSector>({
        query: GET_LOCATION_ENVIRONMENT_MAINTENANCES_QUERY,
        variables: { id, take, after }
      })
      .toPromise()
      .then(({ data }) => data['locationEnvironment']['maintenances']);
  }
}
